import type { AssignmentSource } from "modules/aiMapping/aiAssignmentSources";

export type CostOption = { id: string; name: string };
export type AssignedSource = { id: string; sourceId: string; stallMode?: "count" | "linear_ft" };
export type CostDraft = { id: string; costId: string | null; sources: AssignedSource[] };
export type ProductDraft = {
  id: string;
  productId: string | null;
  sources: AssignedSource[];
  costs: CostDraft[];
  open: boolean;
};

export interface AiSavedAssignment {
  sourceId: string;
  productId?: string | null;
  stallMode?: "count" | "linear_ft";
  additionalCostIds?: string[];
  jobSize?: boolean;
}

export interface AiAssignmentPersistence {
  onAssignSource: (
    source: AssignmentSource,
    productId: string,
    stallMode: "count" | "linear_ft"
  ) => void;
  onUnassignSource: (source: AssignmentSource, productId?: string | null) => void;
  onAssignCost: (
    source: AssignmentSource,
    additionalCostId: string,
    productId?: string | null
  ) => void;
  onRemoveCost: (
    source: AssignmentSource,
    additionalCostId: string,
    productId?: string | null
  ) => void;
}

export const createDraftId = () =>
  `measurement-assignment-${Date.now()}-${Math.round(Math.random() * 100000)}`;

export const selectSx = {
  width: "100%",
  height: 34,
  fontSize: 12,
  border: "1px solid #d0d7de",
  borderRadius: "8px",
  px: 1,
  bgcolor: "#fff",
};
